import { render } from "./ClassItens.vue?vue&type=template&id=34e2e3aa&scoped=true"
import script from "./ClassItens.vue?vue&type=script&lang=js"
export * from "./ClassItens.vue?vue&type=script&lang=js"

import "./ClassItens.vue?vue&type=style&index=0&id=34e2e3aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e2e3aa"]])

export default __exports__